import { AccessTime, CalendarMonth, Update } from '@mui/icons-material'
import { Box, Stack } from '@mui/material'

import type { Appointment } from '../../types.ts'
import Header from '../Header'
import Item from '../Item'

import { getFormattedDateAndTime } from '@/shared/utils'

interface Props {
  appointment: Appointment
}

export const SectionSchedule = ({ appointment }: Props) => {
  return (
    <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 45%' } }}>
      <Header label="Schedule Information" />
      <Stack spacing={2}>
        <Item
          label="Scheduled Time"
          value={getFormattedDateAndTime(appointment.scheduleStartTime) || 'Not scheduled'}
          Icon={CalendarMonth}
        />
        <Item
          label="Created At"
          value={getFormattedDateAndTime(appointment.createdAt)}
          Icon={AccessTime}
        />
        <Item
          label="Last Updated"
          value={getFormattedDateAndTime(appointment.updatedAt)}
          Icon={Update}
        />
      </Stack>
    </Box>
  )
}

export default SectionSchedule
